import React, { useState, useRef, useEffect } from "react";
import { hidLogoIcon, editIconLarge } from "../components/Icons";

interface HeaderProps {
  onMenuToggle?: () => void;
  onNewChat?: () => void;
}

const Header = ({ onMenuToggle, onNewChat }: HeaderProps) => {
  return (
    <header className="chatbot-header">
      <div className="chatbot-header__inner">
        <button
          type="button"
          className="chatbot-header__menu-btn"
          aria-label="Open menu"
          onClick={onMenuToggle}
        >
          <span className="chatbot-header__menu-icon" aria-hidden="true"></span>
        </button>

        <div className="chatbot-header__content">
          <a href="#" className="chatbot-header__brand" aria-label="HID Home">
            <span className="hid-logo">
              {hidLogoIcon()}
            </span>
          </a>
          <div className="chatbot-header__separator"></div>
          <div className="chatbot-header__title">
            <span className="chatbot-header__title-text">
              AIDEN - AI Driven Employee Navigator
            </span>
          </div>
        </div>

        <button
          className="chatbot-header__edit-btn"
          aria-label="New Chat"
          onClick={onNewChat}
        >
          {editIconLarge()}
        </button>
      </div>
    </header>
  );
};

export default Header;
